var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-card',{attrs:{"title":"Dados Pessoais"}},[_c('crud-pessoa-fisica-base',{attrs:{"exclude":_vm.exclude,"optional":_vm.optional}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }